import { render } from "./TicketGallery.vue?vue&type=template&id=cb7d96ea&scoped=true&ts=true"
import script from "./TicketGallery.ts?vue&type=script&lang=ts"
export * from "./TicketGallery.ts?vue&type=script&lang=ts"

import "./TicketGallery.vue?vue&type=style&index=0&id=cb7d96ea&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7d96ea"]])

export default __exports__